export class WorkflowDraftEmailNotification {
    public viewId: number;
    public folderId: string;
    public draftEmailId: number;

    public static fromJson(other: any): WorkflowDraftEmailNotification {
        const instance = new WorkflowDraftEmailNotification();
        instance.viewId = other.ViewId;
        instance.folderId = other.FolderId;
        instance.draftEmailId = other.DraftEmailId;
        return instance;
    }
}
